import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import "typeface-roboto";
import * as serviceWorker from "./serviceWorker";
import App, { Confirm } from "@app";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "@store";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "./animate.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { MsalProvider } from "@azure/msal-react";
import { getMsalInstance } from "@config/entraConfig";

// MSAL's loginPopup navigates the popup itself back to our own origin (Microsoft's
// identity platform has no postMessage-based popup like Google's GIS does). If our
// router mounted in there, PrivateRoute would redirect to /login before MSAL's
// opener-side polling can read the code/state params, hanging loginPopup() forever.
// Skip rendering entirely and let MSAL (running in the opener window) handle it.
if (!window.opener) {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter getUserConfirmation={Confirm}>
          <ReactNotification />
          {/* Both providers are always mounted; the user's chosen login provider decides which one is actually used. */}
          <MsalProvider instance={getMsalInstance()}>
            <GoogleOAuthProvider
              clientId={
                process.env.REACT_APP_GOOGLE_AUTH_CLIENT
                  ? process.env.REACT_APP_GOOGLE_AUTH_CLIENT
                  : ""
              }
            >
              <App />
            </GoogleOAuthProvider>
          </MsalProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
    document.getElementById("root")
  );
  serviceWorker.unregister();
}
